import React from 'react';
import './Content.css';

const Content = ({ header, description, children }) => {
    return (
        <div>                    
            <div className='Content-envelope'>
                <div className='Content-header'>
                    {header}
                </div>
                <div className='Content-description'>{description}</div>
            </div>
            {children}
        </div>
    );
};

export default Content;
